import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import { forwardRef } from 'react'

const OrderNotes = forwardRef(({ order, id }, ref) => {
  return (
    <section className="order-details__section" ref={ref} id={id}>
      <header className="order-details__header -smaller-margin">
        <h4 className="order-details__main-header">Order Notes</h4>
      </header>
      <p className="order-details__description">
        {isEmpty(order?.userNotes) ? 'n/a' : order?.userNotes}
      </p>
    </section>
  )
})

OrderNotes.displayName = 'OrderNotes'

OrderNotes.propTypes = {
  order: PropTypes.object,
  id: PropTypes.string,
}

export default OrderNotes
